import React from 'react';
import { IconProps } from '.';

const SvgBoxUsa = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#fff'
        d='M2 5.333A3.333 3.333 0 0 1 5.333 2h13.334A3.333 3.333 0 0 1 22 5.333v13.334A3.333 3.333 0 0 1 18.667 22H5.333A3.333 3.333 0 0 1 2 18.667V5.333Z'
      />
      <path
        fill='#CB001C'
        fillRule='evenodd'
        d='M20.75 16.167H2.833V14.5H20.75v1.667ZM20.75 19.5H2.833v-1.667H20.75V19.5ZM20.75 12.833H2.833v-1.666H20.75v1.666ZM20.75 9.5H2.833V7.833H20.75V9.5ZM20.75 6.167H2.833V4.5H20.75v1.667Z'
        clipRule='evenodd'
      />
      <path fill='#2A3560' d='M13.667 2H7.833C4.612 2 2 4.425 2 7.417v5.416h11.667V2Z' />
      <path
        fill='#fff'
        d='m5.348 5.797-.163-.556-.163.556H4.5l.424.337-.163.556.424-.346.416.346-.155-.556.416-.337h-.514ZM5.185 7.683l.163.556h.514l-.416.346.155.547-.416-.337-.424.337.163-.547L4.5 8.24h.522l.163-.556ZM5.348 10.681l-.163-.547-.163.547H4.5l.424.347-.163.555.424-.346.416.346-.155-.556.416-.346h-.514ZM6.864 4.63l-.155-.547-.163.547h-.522l.424.346-.163.556.424-.346.416.346-.155-.556.416-.346h-.522ZM6.71 6.526l.154.556h.522l-.416.346.155.547-.416-.338-.424.338.163-.547-.424-.346h.522l.163-.556ZM6.864 9.524l-.155-.547-.163.547h-.522l.424.346-.163.556.424-.346.416.346-.155-.556.416-.346h-.522ZM8.25 5.24l.163.557h.522l-.424.337.163.556-.424-.346-.424.346.163-.556-.424-.337h.522l.163-.556ZM8.413 8.24l-.163-.557-.163.556h-.522l.424.346-.163.547.424-.337.424.337-.163-.547.424-.346h-.522ZM8.25 10.134l.163.547h.522l-.424.347.163.555-.424-.346-.424.346.163-.556-.424-.346h.522l.163-.547ZM9.775 4.083l.163.547h.522l-.424.346.163.556-.424-.346-.424.346.163-.556-.424-.346h.522l.163-.547ZM9.938 7.082l-.163-.556-.163.556H9.09l.424.346-.163.547.424-.338.424.338-.163-.547.424-.346h-.522ZM9.775 8.977l.163.547h.522l-.424.346.163.556-.424-.346-.424.346.163-.556-.424-.346h.522l.163-.547ZM11.478 5.797l-.163-.556-.155.556h-.522l.416.337-.155.556.416-.347.424.347-.163-.556.424-.337h-.522ZM11.315 7.683l.163.556H12l-.424.346.163.547-.424-.337-.416.337.155-.547-.416-.346h.522l.155-.556ZM11.478 10.681l-.163-.547-.155.547h-.522l.416.347-.155.555.416-.346.424.346-.163-.556.424-.346h-.522Z'
      />
      <path
        fill='#E0E0E4'
        fillRule='evenodd'
        d='M18.667 3.25H5.333c-1.15 0-2.083.933-2.083 2.083v13.334c0 1.15.933 2.083 2.083 2.083h13.334c1.15 0 2.083-.933 2.083-2.083V5.333c0-1.15-.933-2.083-2.083-2.083ZM5.333 2A3.333 3.333 0 0 0 2 5.333v13.334A3.333 3.333 0 0 0 5.333 22h13.334A3.333 3.333 0 0 0 22 18.667V5.333A3.333 3.333 0 0 0 18.667 2H5.333Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgBoxUsa;
